;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "InvoiceSummary",

  props: {
    currency: {
      type: String,
      required: true
    },
    gateway_name: {
      type: String,
      required: true
    },
    total_amount: {
      type: Number,
      required: true
    },
    online_convenience_fee: {
      type: Number,
      default: 0
    },
    amount_net: {
      type: Number,
      required: true
    },
    Invoice: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {},


  computed: {
    grandTotal: function grandTotal() {
      return this.total_amount + this.online_convenience_fee;
    }
  },

  methods: {
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    toWholeNumber: function toWholeNumber(value) {
      return Math.round(Number(value));
    },
    roundUp: function roundUp(value) {
      return Math.ceil(Number(value));
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3 py-3 border-bottom"},[_c('p',{staticClass:"mb-2 mb-2 text-center"},[_vm._v("Pay Using "+_vm._s(_vm.gateway_name))]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mb-2"},[_c('p',{staticClass:"mb-0 text-dark"},[_vm._v("Net Amount")]),_vm._v(" "),_c('p',{staticClass:"mb-0 text-dark"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.amount_net))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between mb-2"},[_c('p',{staticClass:"mb-0 text-dark"},[_vm._v("Online Convenience Fee")]),_vm._v(" "),_c('p',{staticClass:"mb-0 text-dark"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.online_convenience_fee))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between"},[_c('p',{staticClass:"mb-0 text-dark"},[_vm._v("Total Payable")]),_vm._v(" "),_c('p',{staticClass:"mb-0 text-dark"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount))])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2bc9f917", __vue__options__)
  } else {
    hotAPI.reload("data-v-2bc9f917", __vue__options__)
  }
})()}